import { DeeplinkKeys } from '@/consts/deepLinks';
import extractUrlParams from '@/utils/ui/extractUrlParams';

import { DeeplinkKind, type Deeplink } from './types';

/**
 * Priority-ordered table mapping URL params to typed deeplinks.
 * Adding a new deeplink kind means one entry here + one branch in the
 * Deeplink union — no changes to consumers.
 *
 * Priority is encoded by array order:
 *   task > projectJson > preset > category
 */
const PRIORITY: Array<{
  key: DeeplinkKeys;
  build: (value: string) => Deeplink;
}> = [
  {
    key: DeeplinkKeys.taskId,
    build: (taskId) => ({ kind: DeeplinkKind.Task, taskId }),
  },
  {
    key: DeeplinkKeys.presetJsonUrl,
    build: (jsonUrl) => ({ kind: DeeplinkKind.ProjectJson, jsonUrl }),
  },
  {
    key: DeeplinkKeys.presetId,
    build: (presetId) => ({ kind: DeeplinkKind.Preset, presetId }),
  },
  {
    key: DeeplinkKeys.category,
    build: (category) => ({ kind: DeeplinkKind.Category, category }),
  },
];

const parseDeeplinks = (): Deeplink => {
  const params = extractUrlParams(PRIORITY.map((entry) => entry.key));
  const match = PRIORITY.find(({ key }) => params[key]);
  if (!match) return { kind: DeeplinkKind.None };
  return match.build(params[match.key] as string);
};

export default parseDeeplinks;
